import { getUTMFieldsFromLocalStorage } from "./utm.util";

interface FormData {
  fullName: string;
  email: string;
  phone?: string;
}
export const handleFreshsalesSubmission = async (formData: FormData) => {
  try {
    if (!formData.fullName || !formData.email) {
      alert('Please fill required fields');
      return false;
    }

    const utmFieldsFromStorage = getUTMFieldsFromLocalStorage();
    const gclid = utmFieldsFromStorage.utm_content;

    const payload = {
      lead: {
        first_name: formData.fullName,
        email: formData.email,
        mobile_number: formData.phone || '',
        
        // Campaign tracking
        first_campaign: utmFieldsFromStorage.utm_campaign,
        first_source: utmFieldsFromStorage.utm_source,
        first_medium: utmFieldsFromStorage.utm_medium,
        last_campaign: utmFieldsFromStorage.utm_campaign,  
        last_source: utmFieldsFromStorage.utm_source,      
        last_medium: utmFieldsFromStorage.utm_medium,     
        latest_campaign: utmFieldsFromStorage.utm_campaign,
        latest_source: utmFieldsFromStorage.utm_source,
        latest_medium: utmFieldsFromStorage.utm_medium,
        
        // Core tracking fields
        medium: utmFieldsFromStorage.utm_medium,
        source: utmFieldsFromStorage.utm_source,
        campaign: utmFieldsFromStorage.utm_campaign,
        keyword: utmFieldsFromStorage.utm_term,
        // lead_source_id:utmFieldsFromStorage.utm_source,
        
        // Time tracking
        first_seen_chat: new Date().toISOString(),
        last_seen_chat: new Date().toISOString(),
        last_seen: new Date().toISOString(),
        last_contacted: new Date().toISOString(),

        
        custom_field: {
          utm_campaign: utmFieldsFromStorage.utm_campaign,
          utm_content: utmFieldsFromStorage.utm_content,
          utm_adgroup: utmFieldsFromStorage.utm_adgroup,
          utm_source: utmFieldsFromStorage.utm_source,
          utm_term: utmFieldsFromStorage.utm_term,
          utm_device: utmFieldsFromStorage.utm_device,
          cf_gclid: gclid,
          last_activity_date_custom: new Date().toISOString(),
          modified_on_custom: new Date().toISOString(),
          // cf_source_medium:utmFieldsFromStorage.utm_source,
          cf_utm_source:utmFieldsFromStorage.utm_source,
          cf_utm_source_calendly:utmFieldsFromStorage.utm_source,
          // cf_source_of_graphy_infromation_for_customer:utmFieldsFromStorage.utm_source,
          // cf_leadsource:utmFieldsFromStorage.utm_source,
          cf_source_of_lead_calendly_or_popup:"popup"
        }
      }
    };

    const response = await fetch('/api/freshsales/leads', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to submit');
    }
    sessionStorage.setItem('exitIntentFormSubmitted', 'true');
    return true;
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
};